import { DocumentVersionType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentVersionEditItem {
    id: string;
    version: number;
    contentVersion: number;
    type: DocumentVersionType;
    content: string;
    modifyUser: IModifyUser;
}

export class DocumentVersionEditItem implements IDocumentVersionEditItem {
    id: string;
    version: number;
    contentVersion: number;
    type: DocumentVersionType;
    content: string;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IDocumentVersionEditItem);
    constructor(obj?: any) {
        this.content = obj && obj.content || "";
        this.id = obj && obj.id || "";
        this.version = obj && obj.version || 0;
        this.contentVersion = obj && obj.contentVersion || 0;
        this.type = obj && obj.type || DocumentVersionType.AutoSave;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}